export default {
  api_url: 'https://pangu-dataapi.nexpcb.com/',
  env: 'Prod',
  echo_channel_prefix: 'Prod_'
}
